import { useQuery } from "@tanstack/react-query";
import { addDays, normalizarFecha } from "../utils/dateUtils";
import { get } from "./divertidogsApiUtils";

export interface ItemListadoMascotasReservas {
  id: string;
  nombre: string;
  idPropietario: string;
  nombresPropietario: string;
  documentoPropietario: string;
  raza: string;
  fechasReservadas: Date[];
}

// Lista las mascotas con las fechas reservadas de spa.
export const listarMascotasReservasSpa = async (): Promise<
  ItemListadoMascotasReservas[] | undefined
> => {
  const resp = await get<Array<ItemListadoMascotasReservas>>(
    "reservas/spa/mascotas"
  );
  return resp?.map((item) => {
    return {
      ...item,
      fechasReservadas: item.fechasReservadas.map((fecha) =>
        normalizarFecha(fecha)
      ),
    };
  });
};

const QUERY_LISTAR_MASCOTAS_RESERVAS_SPA =
  "QUERY_LISTAR_MASCOTAS_RESERVAS_HOTEL";

export const useListarMascotasReservasSpa = () => {
  return useQuery(
    [QUERY_LISTAR_MASCOTAS_RESERVAS_SPA],
    async () => await listarMascotasReservasSpa()
  );
};

export const listarFechasReservadasSpa = async (idMascota: string) => {
  const fechasStr = await get<string[]>(
    `reservas/spa/fechas?idMascota=${idMascota}`
  );
  if (fechasStr === undefined) {
    throw Error("Error al listar fechas reservadas");
  }
  return fechasStr.map((fechaStr) => addDays(new Date(fechaStr), 1));
};

const QUERY_KEY_LISTAR_FECHAS_RESERVADAS_SPA =
  "QUERY_KEY_LISTAR_FECHAS_RESERVADAS_SPA";

export const useListarFechasReservadasSpa = (idMascota: string) => {
  return useQuery(
    [QUERY_KEY_LISTAR_FECHAS_RESERVADAS_SPA],
    async () => await listarFechasReservadasSpa(idMascota)
  );
};
